import React, { useState } from "react";
import axios from "axios";
import { useMutation, useQuery } from "@tanstack/react-query";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { SwalAlert } from "../../components";
export default () => {
  const userData = useSelector((state) => state.app.userData.userData);
  const [activeTab, setActiveTab] = useState("pending");
  const [acceptpopup, setAcceptpopup] = useState(false);
  const [rejectpopup, setRejectpopup] = useState(false);
  const dispatch = useDispatch();
  const [valueHiringRequests, setValueHiringRequests] = useState(null);
  const [showPopup, setShowPopup] = useState(false);
  const [approvedRequests, setApprovedRequests] = useState(null);
  const [popupApprovedRequests, setPopupApprovedRequests] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const navigate = useNavigate();
  const baseURL = process.env.REACT_APP_BASE_URL;
  const fetchHireRequests = async ({ queryKey }) => {
    const accessToken = localStorage.getItem("accessToken");
    const [, empId, status, page] = queryKey;
    const activestatus =
      status === "pending" ? 0 : status === "approved" ? 1 : 2;
    const { data } = await axios.get(
      `${baseURL}/api/v2/hireme/employer/${empId}?status=${activestatus}&page=${page}`,
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );
    return data?.data;
  };
  const {
    data: hireRequests,
    isLoading,
    isError,
    error,
  } = useQuery({
    queryKey: ["hireRequests", userData?.employer?.id, activeTab, currentPage],
    queryFn: fetchHireRequests,
    enabled:
      userData?.employer?.id !== null &&
      userData?.employer?.id !== undefined &&
      (activeTab === "pending" ||
        activeTab === "approved" ||
        activeTab === "rejected"),
  });
  const { has_more_pages, total_pages } = hireRequests || {};
  const startChatMutation = useMutation({
    mutationFn: async (startChat) => {
      const accessToken = localStorage.getItem("accessToken");
      const { data } = await axios.post(
        `${baseURL}/api/chat/start`,
        startChat,
        {
          params: {
            sender_id: startChat?.sender_id,
            receiver_id: startChat?.receiver_id,
          },
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${accessToken}`,
          },
        }
      );

      return data;
    },
    onSuccess: (data) => {
      dispatch({
        type: "UPDATE_USER_CHAT_DATA",
        payload: { userChatData: data?.chat_head },
      });
      navigate(`/chat/${data?.chat_head?.id}`);
    },
    onError: (err) => {
      SwalAlert("Oops...", err?.message, "error");
    },
  });

  const handleStartChat = (receiver_id, sender_id) => {
    startChatMutation.mutate({ receiver_id, sender_id });
  };
  if (isError) {
    return (
      <div className="flex items-center justify-center w-full h-screen">
        <p className="text-secondary">Error loading events: {error.message}</p>
      </div>
    );
  }
  const formatDate = (dateString) => {
    if (!dateString) return "";
    const formatted = new Date(dateString).toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "long",
      year: "numeric",
    });
    const [day, month, year] = formatted.split(" ");
    return `${day} ${month}, ${year}`;
  };
  return {
    setActiveTab,
    setCurrentPage,
    activeTab,
    hireRequests,
    isLoading,
    has_more_pages,
    total_pages,
    currentPage,
    formatDate,
    handleStartChat,
    setValueHiringRequests,
    valueHiringRequests,
    showPopup,
    setShowPopup,
    acceptpopup,
    setAcceptpopup,
    rejectpopup,
    setRejectpopup,
    approvedRequests,
    setApprovedRequests,
    popupApprovedRequests,
    setPopupApprovedRequests,
  };
};
